import { render, staticRenderFns } from "./RoleStep.vue?vue&type=template&id=4440cc68&scoped=true&"
import script from "./RoleStep.vue?vue&type=script&lang=js&"
export * from "./RoleStep.vue?vue&type=script&lang=js&"
import style0 from "./RoleStep.vue?vue&type=style&index=0&id=4440cc68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4440cc68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VSkeletonLoader,VTextField})
